module.exports = __webpack_public_path__ + "static/countries-list-a3769eb841d1afcd638062fbba841b0d.png";